import { useState } from 'react';
import type { Part } from '@etnrlz/shared';
import { Input } from './ui';

/**
 * Campo de busca (typeahead) sobre o inventário de peças. Sugere itens
 * cadastrados; se nada casar, oferece cadastrar o termo digitado.
 */
export function PartSuggest({
  parts,
  exclude,
  placeholder,
  onSelect,
  onCreateNew,
}: {
  parts: Part[];
  exclude: Set<string>;
  placeholder?: string;
  onSelect: (part: Part) => void;
  onCreateNew: (term: string) => void;
}) {
  const [q, setQ] = useState('');
  const [open, setOpen] = useState(false);
  const term = q.trim();
  const lc = term.toLowerCase();

  const matches = term
    ? parts
        .filter(
          (p) =>
            !exclude.has(p.id) &&
            (p.nome.toLowerCase().includes(lc) ||
              p.sku.toLowerCase().includes(lc) ||
              (p.partNumber ?? '').toLowerCase().includes(lc)),
        )
        .slice(0, 6)
    : [];
  const exact = parts.some((p) => p.nome.toLowerCase() === lc);

  return (
    <div className="relative">
      <Input
        value={q}
        placeholder={placeholder ?? 'Buscar no inventário…'}
        onChange={(e) => {
          setQ(e.target.value);
          setOpen(true);
        }}
        onFocus={() => setOpen(true)}
        onBlur={() => setTimeout(() => setOpen(false), 150)}
      />
      {open && term && (
        <div className="absolute z-10 mt-1 w-full card p-1 max-h-56 overflow-y-auto shadow-2xl">
          {matches.map((p) => (
            <button
              key={p.id}
              onMouseDown={() => {
                onSelect(p);
                setQ('');
                setOpen(false);
              }}
              className="w-full text-left px-3 py-2 rounded hover:bg-surface-2 text-sm flex justify-between gap-2"
            >
              <span className="truncate">{p.nome}</span>
              <span className="num text-xs text-muted shrink-0">
                {p.sku} · {p.quantidade} un
              </span>
            </button>
          ))}
          {!exact && (
            <button
              onMouseDown={() => {
                onCreateNew(term);
                setQ('');
                setOpen(false);
              }}
              className="w-full text-left px-3 py-2 rounded hover:bg-surface-2 text-sm text-accent"
            >
              + Cadastrar “{term}”
            </button>
          )}
          {matches.length === 0 && exact && (
            <div className="px-3 py-2 text-sm text-muted">Item já adicionado.</div>
          )}
        </div>
      )}
    </div>
  );
}
